import { AbstractControl, ValidatorFn } from '@angular/forms';
import { PhoneValidationErrors } from '@shared/validation/validation-errors.model';
import { isEmpty } from 'lodash';

export const invalidPhoneNumberError: PhoneValidationErrors = { invalidPhoneNumber: true };

export const phoneNumberValidator =
  (): ValidatorFn =>
  (control: AbstractControl): PhoneValidationErrors | null => {
    const phoneNumberValue = control?.value;

    if (isEmpty(phoneNumberValue)) {
      return null;
    }

    const isValidPhoneNumber = new RegExp('^[+][0-9]{6,}$').test(phoneNumberValue);

    return isValidPhoneNumber ? null : invalidPhoneNumberError;
  };
